export const Gold = '#feb748';
export const White ='#FFFDFA';
export const Black = '#141413';
export const DarkBrown = '#504538';
export const BrownGray = '#b7a99a';
export const Teal = '#00e2c8';
export const DarkTeal = '#00a992';
export const Pink = '#ff5ec2';
export const DiscordBlue = '#5765F2';


export const NewBlueMaybe = '#7FCAFF';